"use client";

import Core from "@/components/core";
import { usePathname } from "next/navigation";
import { useFetchDetailLayananData } from "@/hooks/fetchDetailLayananData";
import { Suspense, useState, useEffect } from "react";
import LoadingSkeleton from "@/app/loading";
import styles from "./detailLayanan.module.css"; // Impor CSS module

const DetailLayananPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const pathname = usePathname();
  const pathPart = pathname?.split("/");
  const nameDevice = pathPart[2];
  const detailPath = pathPart[3];

  const detailLayanan = useFetchDetailLayananData(nameDevice, detailPath);

  const detailItem = detailLayanan[0]; // Mengambil item pertama dari array

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const cleanHtml = (html: string) => {
    return html.replace(/\\n/g, "");
  };

  return (
    <>
      <div className="lg:p-6 md:p-2.5 p-2 rounded-md shadow">
        <Suspense fallback={<LoadingSkeleton />}>
          {isLoading ? (
            <LoadingSkeleton />
          ) : (
            detailItem && (
              <Core.DetailArticles
                title={detailItem.name}
                image={`https://admin.macspace.id/public/${detailItem.image}`}
                alt={detailItem.name}
                content={
                  <div
                    className={styles.contentContainer} // Terapkan CSS module
                    dangerouslySetInnerHTML={{
                      __html: cleanHtml(detailItem.content),
                    }}
                  />
                }
              />
            )
          )}
        </Suspense>
      </div>
    </>
  );
};

export default DetailLayananPage;
